import { Stack, Typography } from "@mui/material";

import { Trans, useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import { useProduct } from "src/context/ProductProvider";
import { useIsMobile } from "src/hooks/useIsMobile";
import { getTermsAndConditions } from "../../utils/getTermsAndConditions";
import { useMemo } from "react";

type TermsOfConditionsTypes = {
  page: string;
  productSlug: string;
  isGlp1: boolean;
  numberOfMonths?: number;
};

const TermsOfConditions = ({
  page,
  productSlug,
  isGlp1,
  numberOfMonths,
}: TermsOfConditionsTypes) => {
  const isMobile = useIsMobile();
  const { t } = useTranslation();
  const billingModel = useProduct((product) => product.billing_model);
  const category = useProduct((product) => product.category.name);
  const { pathname } = useLocation();

  const buttonText = useMemo(() => {
    return t(`${page}.${productSlug}.submit`);
  }, [page, productSlug, t]);

  const termsAndConditions = getTermsAndConditions(
    billingModel,
    pathname,
    category,
    numberOfMonths,
    productSlug,
  );

  return (
    <Stack gap={2}>
      {isGlp1 && productSlug !== "db-ot" ? (
        <Typography
          variant={isMobile ? "subtitle2" : "subtitle1"}
          textAlign="center"
        >
          {t(`${page}.${productSlug}.study`)}
        </Typography>
      ) : null}
      {termsAndConditions.map((tc, idx) => (
        <Typography
          key={idx}
          variant={isMobile ? "subtitle2" : "subtitle1"}
          textAlign="center"
        >
          <Trans
            i18nKey={tc}
            tOptions={{ buttonText }}
            components={{
              1: (
                <Link
                  to="https://www.holavida.com/terms-conditions"
                  target="_blank"
                />
              ),
              2: (
                <Link
                  to="https://www.holavida.com/privacy-policy"
                  target="_blank"
                />
              ),
            }}
          />
        </Typography>
      ))}
    </Stack>
  );
};

export default TermsOfConditions;
